// extracted by mini-css-extract-plugin
export default {"containerBtnVoltar":"btnVoltar_containerBtnVoltar__8cJh0","setaImg":"btnVoltar_setaImg__I0bAi"};